import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {AlertService} from './alert.service';
import {GlobalService} from './global.service';
import {BaseService} from './base.service';
import {Observable} from 'rxjs';
import {AppUrl} from '../constants/app-url';

@Injectable({
  providedIn: 'root'
})
export class AdmissionNotificationService extends BaseService {

  constructor(public http: HttpClient,
              public alertService: AlertService,
              public globalService: GlobalService) {
    super(http, alertService, globalService);
  }

  create(data): Observable<any> {
    return this.postRequest(AppUrl.ADMISSION_NOTIFICATIONS(), data);
  }

  detail(id): Observable<any> {
    return this.getRequest(AppUrl.ADMISSION_NOTIFICATIONS(id));
  }

  get(data): Observable<any> {
    return this.getRequest(AppUrl.ADMISSION_NOTIFICATIONS(), data);
  }

  update(id, data): Observable<any> {
    return this.putRequest(AppUrl.ADMISSION_NOTIFICATIONS(id), data);
  }

  updateStatus(id, data): Observable<any> {
    return this.putRequest(AppUrl.ADMISSION_NOTIFICATIONS_STATUS(id), data);
  }

  delete(id): Observable<any> {
    return this.deleteRequest(AppUrl.ADMISSION_NOTIFICATIONS(id));
  }
}
